import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../services/helpers.js';
import DelayedRedirect from '../../../utils/DelayedRedirect';
import { Transition } from '../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { SelectTheme } from '../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../api/appFetch.js';
import { ChatMessageTriggersUrl, ChatMessageTriggersWithIdUrl } from '../../../constants/apiUrls.js';
import ModifiedByInfo from "../../Common/Footers/ModifiedByInfo";
import EnhancedDropdownComponent from '../../Common/Dropdowns/EnhancedDropdownComponent.js'
import OutletsDropdown from '../../Common/Dropdowns/OutletsDropdown.js';
import LanguageDropdown from '../../Common/Dropdowns/LanguageDropdown.js';

const ChatMessageTriggerTypes = {
    DOSSIER: "DOSSIER",
    ROITEM: "ROITEM"
}

export default class ChatMessageTriggerEditing extends Component {
    constructor(props) {
        super(props);

        var triggerId = undefined;

        if (this.props !== undefined) {
            triggerId = this.props.triggerId;
        }

        this.state = {
            id: triggerId,
            moboOutletId: this.props.outletId !== undefined ? parseInt(this.props.outletId) : 0,
            moboOutletDescription: "",
            type: "",
            trigger: "",
            content: "",
            language: "nl",
            documentURL: "",
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            redirect: false,
            accessibleMoboOutlets: [],
            requestInProgress: false,
            redirect: null,
            open: true,
            chatMessageTriggerWasModified: false,
            editedTriggerId: triggerId,
        };
    }

    componentDidMount() {
        if (this.state.editedTriggerId !== undefined) {
            this.getChatMessageTriggerById();
        }
    };

    isValidForm = () => {
        const { type, trigger, content, documentURL } = this.state

        if (!type || !(type === ChatMessageTriggerTypes.DOSSIER || type === ChatMessageTriggerTypes.ROITEM)) {
            return false;
        }

        if (!trigger || trigger.trim().length === 0) {
            return false;
        }

        if (!content || content.trim().length === 0) {
            return false;
        }

        if (documentURL && documentURL.trim().length === 0) {
            return false;
        }

        return true;
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/chatmessagetriggers" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleSubmit = () => {
        this.saveEditedChatMessageTrigger();
    };

    getChatMessageTriggerById = () => {
        this.setState({ requestInProgress: true });

        appFetch({
            url: ChatMessageTriggersUrl(),
            onSuccess: (data) => {
                let groupItem = [];
                let editedTriggerId = parseInt(this.state.editedTriggerId);
                data.forEach(function (rowData) {
                    if (rowData.id === editedTriggerId) {
                        groupItem = rowData;
                    }
                });

                this.setState({
                    id: groupItem.id,
                    moboOutletId: groupItem.moboOutletId == null ? 0 : groupItem.moboOutletId,
                    moboOutletDescription: groupItem.moboOutletDescription,
                    type: groupItem.type,
                    trigger: groupItem.trigger,
                    content: groupItem.content,
                    language: groupItem.languageCode,
                    documentURL: groupItem.documentURL,
                    modifiedOn: groupItem.modifiedOn,
                    modifiedByName: groupItem.modifiedByName,
                    modifiedByAvatar: groupItem.modifiedByAvatar,
                    loading: false,
                });
                return;
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    };

    saveEditedChatMessageTrigger = () => {
        let resources = this.props.resources;

        if (this.state.trigger.trim().length <= 0) {
            DisplayMessage(resources["InvalidTrigger"], "error");
            return;
        }

        if (this.state.content.trim().length <= 0) {
            DisplayMessage(resources["InvalidChatMessage"], "error");
            return;
        }

        const { trigger, language, content, documentURL } = this.state;

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            trigger: trigger,
            languageCode: language,
            content: content,
            documentURL: documentURL === "" ? null : documentURL,
        });

        const url = ChatMessageTriggersWithIdUrl(this.state.id);

        appFetch({
            url: url,
            method: 'PUT',
            body: json,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    this.setState({
                        updateInProgress: false,
                        chatMessageTriggerWasModified: true,
                        redirect: "/chatmessagetriggers"
                    });

                    DisplayMessage(resources["ChatMessageTriggerWasEdited"], "success");
                }
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    renderForm() {
        const { type, trigger, content, language, documentURL, moboOutletId, modifiedByAvatar, modifiedByName, modifiedOn } = this.state;
        var helperTextTrigger = trigger.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        var helperTextContent = content.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        var resources = this.props.resources;

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form>
                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={moboOutletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6 helper-text-red"
                            disabled
                        />
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <div className="col-6 helper-text-red" style={{ padding: 0 }}>
                            <EnhancedDropdownComponent
                                id="chatmessagetrigger-type"
                                labelText={resources["Type"]}
                                value={type}
                                options={[
                                    {key: ChatMessageTriggerTypes.DOSSIER, name: resources["Dossier"]},
                                    {key: ChatMessageTriggerTypes.ROITEM, name: resources["ROItem"]},
                                ]}
                                handleChange={this.handleChange}
                                addMarginBottom={false}
                                inputName="type"
                                disabled
                            />
                        </div>
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextTrigger} id="chatmessagetrigger-trigger"
                                value={trigger} label={resources["Trigger"]}
                                helperText={resources["InputOfTriggerIsMandatory"]}
                                variant="outlined" name="trigger" onChange={this.handleChange} inputProps={{ maxLength: 25 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <LanguageDropdown
                            resources={resources}
                            language={language}
                            onLanguageChange={this.handleChange}
                            containerClass="col-6 helper-text-red"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextContent} id="chatmessagetrigger-content"
                                value={content} label={resources["ChatMessage"]}
                                helperText={resources["InputOfContentIsMandatory"]}
                                variant="outlined" name="content" onChange={this.handleChange} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="chatmessagetrigger-url"
                                value={documentURL} label={resources["URL"]}
                                variant="outlined" name="documentURL" onChange={this.handleChange} />
                        </ThemeProvider >
                    </Form.Group>
                </Form>
                <ModifiedByInfo
                    resources={resources}
                    modifiedByAvatar={modifiedByAvatar}
                    modifiedOn={modifiedOn}
                    modifiedByName={modifiedByName}
                    className="mt-3"
                  />
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>;
    }


    render() {
        const { redirect, open, chatMessageTriggerWasModified, outletId, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: chatMessageTriggerWasModified, outletId } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-chatmessagetrigger" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["EditChatMessageTrigger"]}
                            </Typography>
                            <Button id="chatmessagetrigger-update" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}